import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import { useFormik } from 'formik';
import React, { use, useEffect, useState } from 'react';
import * as Yup from "yup";
import { cfpBaseUrl } from "../../network/urls";
import { Backdrop, Button, Grid, InputAdornment, MenuItem, Select, TextField, Typography,InputLabel,FormHelperText } from '@mui/material';
import AppLoader from '../AppLoader/AppLoader';
import { useLocation, useNavigate } from 'react-router-dom';
import { allCompaniesAPI, documentValidation, allEmployeeRoleTypes, allCFCLevelsAPI, handleFileUpload, isImage, isPdf, colors } from '../../services/Functions';
import FormControl from '@mui/material/FormControl';
import Error from '../../components/error/error';
import FormControlLabel from '@mui/material/FormControlLabel';
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { documentExtensions, portalName } from "../../utils/PortalName";
import IconButton from '@mui/material/IconButton';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { AllRoles } from '../../network/APIs/APIs';
import UserIconImage from '../../images/user.jpg';
import { useSelector } from 'react-redux';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import pdfIcon from "../../images/pdfIcon.png";
import "./updateUserPopup.scss";

/** Layout for title row; background from `.user-mgmt-modal-header` in userMgmtModalChrome.scss */
const TRANSFER_DIALOG_HEADER_SX = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 2,
};

/** Same primary action styling as User Management modals */
const TRANSFER_DIALOG_PRIMARY_BUTTON_SX = {
  px: 3.5,
  py: 1,
  minWidth: 130,
  borderRadius: 1.5,
  fontWeight: 700,
  letterSpacing: "0.06em",
  textTransform: "none",
  color: "#fff",
  bgcolor: "#003971",
  "&:hover": { bgcolor: "#002a56" },
  "&.Mui-disabled": {
    bgcolor: "rgba(0, 57, 113, 0.42)",
    color: "rgba(255, 255, 255, 0.9)",
  },
  boxShadow: "0 2px 8px rgba(0, 57, 113, 0.35)",
};

const UpdateUserPopup = ({ open, onClose, userToEdit,onUpdated,onTransferSuccess  }) => {
    const [transferLetterDoc, setTransferLetterDoc] = useState("");
    const [transferLetterThumbnail, setTransferLetterThumbnail] = useState("");
    const [transferLetterError, setTransferLetterError] = useState('')
    const [cfcLevelList, setCFCLevelList] = useState([]);
    const [file, setFile] = useState('');
    const [fileThumbnail, setFileThumbnail] = useState('');
    const [viewBackdrop, setViewBackdrop] = React.useState(false);
    const [userState, setUserState] = useState();
    const [formvalues, setFormValues] = useState();
    const { state } = useLocation();
    const [companyList, setCompanyList] = useState([]);
    const [allRoles, setAllRoles] = useState();
    const [hierarchyList, setHierarchyList] = useState([]);
    const [cfcsList, setcfcsList] = useState([]);
    const [allCfcs, setAllCfcs] = useState([]);
    const [circleList, setCircleList] = useState([]);
    const [divisionList, setDivisionList] = useState([]);
    const [subdivisionList, setsubDivisionList] = useState([]);
    const [showPassword, setShowPassword] = React.useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
    const [error, setError] = useState('');
    const [employeeType, setEmployeeType] = useState()
    const [selectedRoleType, setSelectedRoleType] = useState("");
    const [selectedRoleId, setSelectedRoleId] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [isRoleManuallyChanged, setIsRoleManuallyChanged] = useState(false);

   const [technicalLevels, setTechnicalLevels] = useState([
  { value: 1, label: 'PITC' },
  { value: 2, label: 'DISCO' },
  { value: 3, label: 'Circle' },
  { value: 4, label: 'Division' },
 { value: 52, label: 'Sub Division' },
]);
    const handleClickShowPassword = () => setShowPassword((show) => !show);
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
    const handleMouseDownConfirmPassword = (event) => {
        event.preventDefault();
    };

    const TransferDocuments = (event) => {
    if (event.target.files) {
        const newFileName = 'TransferDocuments.' + event.target.files[0].name.split(".").pop();
        handleFileUpload(event, handleChange, setTransferLetterDoc, setTransferLetterError, setTransferLetterThumbnail, newFileName);
        
        // ADD THIS:
        setFieldValue('iv_transfer_letter', event.target.files[0]);
    }
};
    useEffect(() => {
        if (userToEdit && userToEdit.roleTypeId) {
            setSelectedRoleType(userToEdit.roleTypeId.toString());
            setSelectedRoleId(userToEdit.role_id.toString());
            setSelectedStatus(userToEdit.status);
        }
    }, [userToEdit]);
    useEffect(() => {
        const callCFCLevels = async () => {
            setViewBackdrop(true)
            let cfcLevelsList = await allCFCLevelsAPI(token, cfpBaseUrl)
            if (cfcLevelsList) {
                if (hierarchy != 1) {
                    cfcLevelsList = cfcLevelsList.filter(item => parseInt(item.cfcLevelId) >= parseInt(hierarchy))
                }
                setCFCLevelList(cfcLevelsList)
            }
            setViewBackdrop(false);
        }
        callCFCLevels()
    }, [])

    const navigate = useNavigate()
    const initialValues = {
        iv_office_code: '',
        iv_level: '',
        iv_full_name: '',
        iv_user_name: '',
        // Iv_roleType:'',
        // iv_pin_code: '',
        // iv_password: '',
        // iv_confirm_password: '',
        iv_email: '',
        iv_phone_no: '',
        iv_cnic: '',
        iv_role: selectedRoleId || '',
        iv_company: '',
        iv_circle: '',
        iv_division: '',
        iv_support_center: '',
        iv_sub_division: '',
        // iv_status: 1,
        iv_transfer_letter: null,
        iv_transfer_date: '',
        iv_remarks: '',
    }
    let { token, code: userOfficeCode, userId: updatedBy, permissions, hierarchy } = useSelector((state) => state.auth)
    let userCompany = userOfficeCode.slice(0, 2);

    useEffect(() => {
        const callAllCompanies = async () => {
            setViewBackdrop(true)
            let companiesList = await allCompaniesAPI(token, cfpBaseUrl)
            if (companiesList) {
                companiesList = companiesList.filter(item => item.companyCode != 1)
                let cpList = companiesList.map(item => ({
                    code: item.companyCode,
                    name: item.companyName
                }))
                cpList.unshift({ code: 10, name: 'PITC' })
                setCompanyList(cpList)
            }
            setViewBackdrop(false);
        }
        callAllCompanies()
    }, [])

    useEffect(() => {
        setUserState(userToEdit)
    }, [userToEdit])
    useEffect(() => {
        const getAllEmployeeRoleTypes = async () => {
            setViewBackdrop(true)
            let employeeRoleTypes = await allEmployeeRoleTypes(token, cfpBaseUrl)
            if (employeeRoleTypes) {
                setEmployeeType(employeeRoleTypes)
            }
            setViewBackdrop(false);
        }
        getAllEmployeeRoleTypes()
    }, [])
    useEffect(() => {
        const getAllRoles = async () => {
            let allroles = await AllRoles(token, permissions)
            setAllRoles(allroles)
        }
        getAllRoles()
    }, [])

    const { values, errors, touched, handleChange, handleBlur, handleSubmit, setFieldValue, resetForm, validateForm,setTouched    } = useFormik({

        initialValues,
        validationSchema: Yup.object({
            iv_office_code: Yup.string().optional(),
            iv_level: Yup.mixed().required('Level is required'),
            // iv_status: Yup.mixed().optional('Status is required'),
            // iv_full_name: Yup.string().required("Fullname is required").min(3, `Name can't be less than 3 characters!`).max(50, `Name can't be more than 50 characters!`),
            // iv_user_name: Yup.string().required("Username is required"),
            // Iv_roleType: Yup.string().required("Employee Type is required"),
            // iv_pin_code: Yup.number().typeError("Pincode must be in number").optional(),
            // iv_password: Yup.string().min(8, "Password can't be less than 8 characters!").max(16, 'Password can not be more than 16 digits!').required("Password is required"),
            // iv_password: Yup.string()
            //   .required("Password is required")
            //   .test("len", "Password must be between 8 and 16 characters", val =>
            //     val && val.length >= 8 && val.length <= 16
            //   )
            //   .test("lowercase", "At least 1 lowercase letter required", val =>
            //     /[a-z]/.test(val)
            //   )
            //   .test("uppercase", "At least 1 uppercase letter required", val =>
            //     /[A-Z]/.test(val)
            //   )
            //   .test("number", "At least 1 number required", val =>
            //     /[0-9]/.test(val)
            //   )
            //   .test("special", "At least 1 special character required", val =>
            //     /[^A-Za-z0-9]/.test(val)
            //   ),
            // iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_password'), null], 'Password and Confirm password must match').optional("Confirm password is required"),
            // iv_email: Yup.string().email('Enter valid email!').required("Email is required"),
            // iv_phone_no: Yup.string().min(11, "Phone no. can not less than 11 digits.").max(11, "Phone no. can not greater than 11 digits.").required("Phone no. is required").matches(/^03[0-9]{2}[0-9]{7}$/, "Enter Phone no. as 03001234567."),
            // iv_cnic: Yup.string().min(13, "CNIC no. can not less than 13 digits.").max(13, "CNIC no. can not greater than 13 digits.").required("CNIC No. is required").matches(/^[0-9]+$/, "Enter CNIC No. as 3520212345678"),

            iv_role: Yup.mixed().required('Role is required'),
            iv_company: Yup.string().when('iv_level', {
                is: (value) => value > 1,
                then: Yup.string().required("Company is required!"),
                otherwise: Yup.string().optional()
            }),
            iv_circle: Yup.string().when('iv_level', {
                is: (value) => value > 2,
                then: Yup.string().required("Circle is required!"),
                otherwise: Yup.string().optional()
            }),
            iv_division: Yup.string().when('iv_level', {
    is: (value) => [4, 51].includes(Number(value)),
    then: Yup.string().required("Division is required!"),
    otherwise: Yup.string().optional()
}),
            //             iv_support_center: Yup.string().when('iv_level', {
            //   // Check if selectedRoleType is "1" AND iv_level is 2 or greater
            //   is: (iv_level) => selectedRoleType == "1" && Number(iv_level) >= 2,
            //   then: Yup.string().required("Customer Support Center is required!"),
            //   otherwise: Yup.string().optional()
            // }),
            iv_support_center: Yup.string()
    .nullable()  // Add this
    .when('iv_level', {
        is: (iv_level) => selectedRoleType == "1" && Number(iv_level) >= 2,
        then: Yup.string().required("Customer Support Center is required!"),
        otherwise: Yup.string().nullable().optional()  // Add nullable here too
    }),
            iv_sub_division: Yup.string().when('iv_level', {
  is: (value) => [5, 52].includes(Number(value)),     // ← change here
  then: Yup.string().required("Sub division is required!"),
  otherwise: Yup.string().optional()
}),
            iv_transfer_letter: Yup.mixed().required("Trans. letter is required"),
            iv_transfer_date: Yup.mixed().required('Transfer date is required'),
            iv_remarks: Yup.string()
                .min(5, "Remarks should be at least 5 characters.")
                .max(200, "Remarks should not exceed 200 characters.")
                .required("Enter remarks."),
        }),

        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);
            myHeaders.append("Content-Type", "application/json");

            const raw = JSON.stringify({
                "userId": userState.userId,
                "roleTypeId": parseInt(userState.roleTypeId),
                "code": parseInt(values.iv_office_code),
                "companyCode": parseInt(values.iv_company),
                "circleCode": parseInt(values.iv_circle || 0),
                "divisionCode": parseInt(values.iv_division || 0),
                "subDivisionCode": parseInt(values.iv_sub_division || 0),
                "hierarchy": parseInt(values.iv_level),
                "remarks": values.iv_remarks,
                "transferDate": values.iv_transfer_date,
                "roleId":values.iv_role,
                "transferLetter": transferLetterThumbnail,
            });

            const requestOptions = {
                method: "PUT",
                headers: myHeaders,
                body: raw,
                redirect: "follow"
            };

            await fetch(cfpBaseUrl + "customerFaciliationPortal/transferPosting", requestOptions)
                .then(response => response.json())
                .then(result => {
                    if (result.status === '200') {
                        onTransferSuccess?.(result.message || "Transfer completed successfully");
            onClose();
                    } else {
                        setError(result.message)
                    }
                });
            setViewBackdrop(false);

        }
//         onSubmit: async (values, { resetForm }) => {
//     console.log("Form submitted!"); // Add this first
//     // rest of your code...
// }
    })
    useEffect(() => {
        if (hierarchy != 1) {
            let hierarchyArray = technicalLevels
            setTechnicalLevels(hierarchyArray.filter(item => item.value >= parseInt(hierarchy)))
            setFieldValue('iv_company', userCompany)
        }
    }, [hierarchy, userCompany])

    useEffect(() => {
        if (values.iv_company) {
            const fetchCfcs = async () => {
                setViewBackdrop(true)
                try {
                    var formdata = new FormData();
                    formdata.append("companyCode", values.iv_company == 10 ? '' : parseInt(values.iv_company));
                    const myHeaders = new Headers();
                    myHeaders.append("Authorization", token);
                    var requestOptions = {
                        method: 'POST',
                        body: formdata,
                        headers: myHeaders,
                        redirect: 'follow',
                    };
                    const response = await fetch(cfpBaseUrl + "customerFaciliationPortal/getAllCFCs", requestOptions);
                    const result = await response.json();
                    if (result.status === '200') {
                        setAllCfcs(result.data)
                    }
                }
                catch (e) {
                }
                setViewBackdrop(false)
            }
            fetchCfcs()
        }
    }, [values.iv_company])

   // Most safe & commonly working version in real DISCO systems
useEffect(() => {
    if (!allCfcs?.length) {
        setcfcsList([]);
        return;
    }

    let filtered = [...allCfcs];

    filtered = filtered.filter(cfc => 
        String(cfc.cfcLevelId) === String(values.iv_level)
    );

    if ([5, 52].includes(Number(values.iv_level))) {
        if (values.iv_sub_division) {
            filtered = filtered.filter(cfc => 
                String(cfc.subDivisionCode || '') === String(values.iv_sub_division)
            );
        }
        else if (values.iv_division && filtered.length === 0) {
            filtered = allCfcs.filter(cfc => 
                String(cfc.cfcLevelId) === String(values.iv_level) &&
                String(cfc.divisionCode || '') === String(values.iv_division)
            );
        }
    }
    // Division level check اب 4 اور 51 دونوں کو سپورٹ کرے گا
    else if ([4, 51].includes(Number(values.iv_level)) && values.iv_division) {
        filtered = filtered.filter(cfc => 
            String(cfc.divisionCode || '') === String(values.iv_division)
        );
    }
    else if (values.iv_circle && values.iv_level >= 3) {
        filtered = filtered.filter(cfc => 
            String(cfc.circleCode || '') === String(values.iv_circle)
        );
    }

    // فال بیک منطق
    if (filtered.length === 0 && values.iv_sub_division && values.iv_division) {
        filtered = allCfcs.filter(cfc => 
            String(cfc.cfcLevelId) === String(values.iv_level) &&
            String(cfc.divisionCode || '') === String(values.iv_division)
        );
    }

    setcfcsList(filtered);

}, [allCfcs, values.iv_level, values.iv_circle, values.iv_division, values.iv_sub_division]);

    useEffect(() => {
        if (userState) {
            setFieldValue('iv_office_code', userState.cscId ? userState.cscId : userState.code)
            setFieldValue('iv_level', userState.hierarchy)
            setFieldValue('iv_full_name', userState.name)
            setFieldValue('iv_user_name', userState.userId)
            setFieldValue('iv_email', userState.email)
            setFieldValue('iv_phone_no', userState.phoneNo)
            setFieldValue('iv_cnic', userState.CNIC)
            setFieldValue('iv_role', userState.role_id)
            setFieldValue('iv_company', userState.companyCode)
            setFieldValue('iv_circle', userState.circleCode)
            setFieldValue('iv_division', userState.divisionCode)
            setFieldValue('iv_support_center', userState.cscId)
            setFieldValue('iv_sub_division', userState.subDivisionCode)
            setFieldValue('iv_status', userState.status)
            setFieldValue('iv_picture', userState.profilePicture)
            setFileThumbnail(userState.profilePicture)
            var formdata = new FormData();
            formdata.append("companyCode", parseInt(userState.companyCode));
            const myHeaders = new Headers();
            myHeaders.append("Authorization", token);;
            var requestOptions = {
                method: 'POST',
                body: formdata,
                headers: myHeaders,
                redirect: 'follow',
            };
            fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
                .then(response => response.json())
                .then(result => {
                    let hierarchyArray = result.message
                    let sortedSdArray = hierarchyArray.sort(function (a, b) {
                        var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        if (sdA < sdB) {
                            return -1; // nameA comes before nameB in the sorted order
                        }
                        if (sdA > sdB) {
                            return 1; // nameA comes after nameB in the sorted order

                        }
                        return 0; // names are equal, their order doesn't matter
                    });

                    let uniqueCircles = []
                    for (let i = 0; i < sortedSdArray.length; i++) {
                        const circle = sortedSdArray[i];
                        const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
                        if (!existingCircle) {
                            uniqueCircles.push({
                                code: circle.circleCode,
                                name: circle.circleName
                            });
                        }
                    }

                    let sortedCircleArray = uniqueCircles.sort(function (a, b) {
                        var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        if (circleA < circleB) {
                            return -1; // nameA comes before nameB in the sorted order
                        }
                        if (circleA > circleB) {
                            return 1; // nameA comes after nameB in the sorted order
                        }
                        return 0; // names are equal, their order doesn't matter
                    });

                    let uniqueDivisions = []
                    for (let i = 0; i < sortedSdArray.length; i++) {
                        const division = sortedSdArray[i];
                        if (division.circleCode === userState.circleCode) {
                            const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
                            if (!existingDivision) {
                                uniqueDivisions.push({
                                    code: division.divisionCode,
                                    name: division.divisionName
                                });
                            }
                        }
                    }

                    let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
                        var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        if (divisionA < divisionB) {
                            return -1; // nameA comes before nameB in the sorted order
                        }
                        if (divisionA > divisionB) {
                            return 1; // nameA comes after nameB in the sorted order
                        }
                        return 0; // names are equal, their order doesn't matter
                    });

                    let uniquesubDivisions = []
                    for (let i = 0; i < sortedSdArray.length; i++) {
                        const subdivision = sortedSdArray[i];
                        if (subdivision.divisionCode === userState.divisionCode) {
                            const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
                            if (!existingsubDivision) {
                                uniquesubDivisions.push({
                                    code: subdivision.subDivisionCode,
                                    name: subdivision.subDivisionName
                                });
                            }
                        }
                    }

                    let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
                        var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                        if (subdivisionA < subdivisionB) {
                            return -1; // nameA comes before nameB in the sorted order
                        }
                        if (subdivisionA > subdivisionB) {
                            return 1; // nameA comes after nameB in the sorted order
                        }
                        return 0; // names are equal, their order doesn't matter
                    });

                    setHierarchyList(sortedSdArray)
                    setCircleList(sortedCircleArray)
                    setDivisionList(sortedDivisionArray)
                    setsubDivisionList(sortedsubDivisionArray)
                }
                )
                .catch(() => {});
        }
    }, [userState])


    useEffect(() => {
        if (file) {
            setFieldValue('iv_picture', fileThumbnail)
        }
    }, [file])

   const handleChangeCompany = (event) => {
    handleChange(event);
    setFieldValue('iv_office_code', event.target.value);

    // Circle reset
    if (values.iv_level >= 3) {
        setFieldValue('iv_circle', '');
    } else {
        setFieldValue('iv_circle', 0);
    }

    // Division reset (اب 4 اور 51 دونوں)
    if ([4, 51].includes(Number(values.iv_level))) {
        setFieldValue('iv_division', '');
    } else {
        setFieldValue('iv_division', 0);
    }

    // Sub Division reset (اب 5 اور 52 دونوں)
    if ([5, 52].includes(Number(values.iv_level))) {
        setFieldValue('iv_sub_division', '');
    } else {
        setFieldValue('iv_sub_division', 0);
    }

    // Support Center (اگر ضرورت ہو)
    if (values.iv_level === 51) {
        setFieldValue('iv_support_center', '');
    } else {
        setFieldValue('iv_support_center', '');
    }

    // fetch hierarchy data
    var formdata = new FormData();
    formdata.append("companyCode", event.target.value);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);
    var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
    };

    fetch(cfpBaseUrl + "customerFaciliationPortal/subDivWithCompDetails", requestOptions)
        .then(response => response.json())
        .then(result => {
                let hierarchyArray = result.message
                let sortedSdArray = hierarchyArray.sort(function (a, b) {
                    var sdA = a.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
                    var sdB = b.circleName.toUpperCase(); // convert to uppercase to ignore case sensitivity
                    if (sdA < sdB) {
                        return -1; // nameA comes before nameB in the sorted order
                    }
                    if (sdA > sdB) {
                        return 1; // nameA comes after nameB in the sorted order

                    }
                    return 0; // names are equal, their order doesn't matter
                });
                setHierarchyList(sortedSdArray)
                // handleChange(event.target.value);
            }
            )
        .catch(() => {});
};

    useEffect(() => {
        if (hierarchyList) {
            let hierarchyArray = hierarchyList
            let uniqueCircles = []
            for (let i = 0; i < hierarchyArray.length; i++) {
                const circle = hierarchyArray[i];
                const existingCircle = uniqueCircles.find(c => c.code === circle.circleCode);
                if (!existingCircle) {
                    uniqueCircles.push({
                        code: circle.circleCode,
                        name: circle.circleName
                    });
                }
            }

            let sortedCircleArray = uniqueCircles.sort(function (a, b) {
                var circleA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                var circleB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                if (circleA < circleB) {
                    return -1; // nameA comes before nameB in the sorted order
                }
                if (circleA > circleB) {
                    return 1; // nameA comes after nameB in the sorted order
                }
                return 0; // names are equal, their order doesn't matter
            });
            setCircleList(sortedCircleArray)
        }
    }, [hierarchyList])

   const handleChangeCircle = (event) => {
    handleChange(event);

    const selectedCircle = circleList.find((item) => item.code === event.target.value);
    if (selectedCircle) {
        setFieldValue('iv_office_code', selectedCircle.code);
    }

    // Division reset (اب 4 اور 51 دونوں)
    if ([4, 51].includes(Number(values.iv_level))) {
        setFieldValue('iv_division', '');
    } else {
        setFieldValue('iv_division', 0);
    }

    // Sub Division reset (اب 5 اور 52 دونوں)
    if ([5, 52].includes(Number(values.iv_level))) {
        setFieldValue('iv_sub_division', '');
    } else {
        setFieldValue('iv_sub_division', 0);
    }

    // Support Center reset (اگر ضرورت ہو)
    if (values.iv_level === 51) {
        setFieldValue('iv_support_center', '');
    } else {
        setFieldValue('iv_support_center', '');
    }
};

    useEffect(() => {
        if (values.iv_circle) {
            let hierarchyArray = hierarchyList
            let uniqueDivisions = []
            for (let i = 0; i < hierarchyArray.length; i++) {
                const division = hierarchyArray[i];
                if (division.circleCode === values.iv_circle) {
                    const existingDivision = uniqueDivisions.find(c => c.code === division.divisionCode);
                    if (!existingDivision) {
                        uniqueDivisions.push({
                            code: division.divisionCode,
                            name: division.divisionName
                        });
                    }
                }
            }

            let sortedDivisionArray = uniqueDivisions.sort(function (a, b) {
                var divisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                var divisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                if (divisionA < divisionB) {
                    return -1; // nameA comes before nameB in the sorted order
                }
                if (divisionA > divisionB) {
                    return 1; // nameA comes after nameB in the sorted order
                }
                return 0; // names are equal, their order doesn't matter
            });
            setDivisionList(sortedDivisionArray)
        }
    }, [values.iv_circle])

    const handleChangeDivision = (event) => {
    handleChange(event);

    const selectedDivision = divisionList.find((item) => item.code === event.target.value);
    if (selectedDivision) {
        setFieldValue('iv_office_code', selectedDivision.code);
    }

    // Sub Division reset (اگر sub-division دکھ رہا ہو)
    if ([5, 52].includes(Number(values.iv_level))) {
        setFieldValue('iv_sub_division', '');
    } else {
        setFieldValue('iv_sub_division', 0);
    }

    // Support Center (اگر ضرورت ہو)
    if (values.iv_level === 51) {
        setFieldValue('iv_support_center', '');
    } else {
        setFieldValue('iv_support_center', '');
    }
};

    useEffect(() => {
        if (values.iv_division) {
            let hierarchyArray = hierarchyList
            let uniquesubDivisions = []
            for (let i = 0; i < hierarchyArray.length; i++) {
                const subdivision = hierarchyArray[i];
                if (subdivision.divisionCode === values.iv_division) {
                    const existingsubDivision = uniquesubDivisions.find(c => c.code === subdivision.subDivisionCode);
                    if (!existingsubDivision) {
                        uniquesubDivisions.push({
                            code: subdivision.subDivisionCode,
                            name: subdivision.subDivisionName
                        });
                    }
                }
            }


            let sortedsubDivisionArray = uniquesubDivisions.sort(function (a, b) {
                var subdivisionA = a.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                var subdivisionB = b.name.toUpperCase(); // convert to uppercase to ignore case sensitivity
                if (subdivisionA < subdivisionB) {
                    return -1; // nameA comes before nameB in the sorted order
                }
                if (subdivisionA > subdivisionB) {
                    return 1; // nameA comes after nameB in the sorted order
                }
                return 0; // names are equal, their order doesn't matter
            });
            setsubDivisionList(sortedsubDivisionArray)
        }
    }, [values.iv_division])

    // const handleLevelChange = (event) => {
    //   handleChange(event)
    //   if (hierarchy == 1) {
    //     values.iv_role = '';
    //     if (event.target.value === 1) {
    //       values.iv_company = 1
    //       values.iv_circle = 0
    //       values.iv_division = 0
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = event.target.value
    //     }
    //     else if (event.target.value === 2) {
    //       values.iv_company = ''
    //       values.iv_circle = 0
    //       values.iv_division = 0
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = 0
    //     }
    //     else if (event.target.value === 3) {
    //       if (values.iv_company === 1) {
    //         values.iv_company = ''
    //       }
    //       values.iv_circle = ''
    //       values.iv_division = 0
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = ''
    //     }
    //     else if (event.target.value === 4) {
    //       if (values.iv_company === 1) {
    //         values.iv_company = ''
    //       }
    //       values.iv_division = ''
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = ''
    //     }
    //     else if (event.target.value === 51) {
    //       if (values.iv_company === 1) {
    //         values.iv_company = ''
    //       }
    //       values.iv_support_center = ''
    //       values.iv_sub_division = 0
    //       values.iv_office_code = ''
    //     }
    //     else if (event.target.value === 52) {
    //       if (values.iv_company === 1) {
    //         values.iv_company = ''
    //       }
    //       values.iv_support_center = 0
    //       values.iv_sub_division = ''
    //       values.iv_office_code = ''
    //     }
    //   } else {
    //     if (event.target.value === 2) {
    //       values.iv_company = userCompany
    //       values.iv_circle = 0
    //       values.iv_division = 0
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = userCompany
    //     }
    //     else if (event.target.value === 3) {
    //       values.iv_company = userCompany
    //       values.iv_circle = ''
    //       values.iv_division = 0
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = userCompany
    //     }
    //     else if (event.target.value === 4) {
    //       values.iv_company = userCompany
    //       values.iv_division = ''
    //       values.iv_support_center = 0
    //       values.iv_sub_division = 0
    //       values.iv_office_code = userCompany
    //     }
    //     else if (event.target.value === 52) {
    //       values.iv_company = userCompany
    //       values.iv_support_center = 0
    //       values.iv_sub_division = ''
    //       values.iv_office_code = userCompany
    //     }
    //   }
    // }
   const handleLevelChange = (event) => {
    handleChange(event);
    setFieldValue('iv_role', '');

    const selectedLevel = Number(event.target.value);

    if (selectedLevel === 1) {
        setFieldValue('iv_company', 10);
        setFieldValue('iv_circle', 0);
        setFieldValue('iv_division', 0);
        setFieldValue('iv_support_center', '');
        setFieldValue('iv_sub_division', 0);
        setFieldValue('iv_office_code', 1000001);
    }
    else if (selectedLevel === 2) {
        setFieldValue('iv_circle', 0);
        setFieldValue('iv_division', 0);
        setFieldValue('iv_support_center', '');
        setFieldValue('iv_sub_division', 0);
        setFieldValue('iv_office_code', 0);
    }
    else if (selectedLevel === 3) {
        if (values.iv_company === 1) {
            setFieldValue('iv_company', '');
        }
        setFieldValue('iv_circle', '');
        setFieldValue('iv_division', 0);
        setFieldValue('iv_support_center', '');
        setFieldValue('iv_sub_division', 0);
        setFieldValue('iv_office_code', '');
    }
    // ── Division levels (4 and 51) ───────────────────────────────
    else if ([4, 51].includes(selectedLevel)) {
        if (values.iv_company === 1) {
            setFieldValue('iv_company', '');
        }
        setFieldValue('iv_division', '');
        setFieldValue('iv_support_center', '');
        setFieldValue('iv_sub_division', 0);
        setFieldValue('iv_office_code', '');
    }
    // ── Sub-division levels (5 and 52) ───────────────────────────
    else if ([5, 52].includes(selectedLevel)) {
        if (values.iv_company === 1) {
            setFieldValue('iv_company', '');
        }
        setFieldValue('iv_support_center', '');
        setFieldValue('iv_sub_division', '');
        setFieldValue('iv_office_code', '');
    }
    // Optional: keep 51 as separate block if you want special behavior
    // else if (selectedLevel === 51) {
    //     // ... same as [4,51] block or add extra logic if needed
    // }
};
    const handleChangeSupportCenter = (event) => {
        handleChange(event);
        setFieldValue('iv_office_code', event.target.value);
    };

    const handleChangeSubDivision = (event) => {
        handleChange(event);
        setFieldValue('iv_office_code', event.target.value);
    };

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setFormValues(true);
        }, 500);

        // Clear the timeout to prevent the state update if the component unmounts or userState changes
        return () => clearTimeout(timeoutId);
    }, [userState]);


    const errorCloses = () => {
        setError('')
    }


    const handleChangeRoleType = (event) => {

        setSelectedRoleType(event.target.value);
    };
    const handleDialogClose = () => {
        resetForm();
        setTransferLetterThumbnail(null);
        setTransferLetterDoc(null);
        setTransferLetterError('');
        setError('');
        onClose()
    };
    
    return (
        <Dialog
            open={open}
            onClose={handleDialogClose}
            fullWidth
            maxWidth="lg"
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    overflow: "hidden",
                    boxShadow: "0 16px 48px rgba(0, 52, 120, 0.18)",
                },
            }}
        >
            <DialogTitle
                component="div"
                className="user-mgmt-modal-header"
                sx={TRANSFER_DIALOG_HEADER_SX}
            >
                <Typography variant="h6" sx={{ fontWeight: 700, lineHeight: 1.2 }}>
                    Transfer Posting of ({userState ? userState.name : ''} - {userState ? userState.userId : ''})
                </Typography>
                <IconButton
                    id="clearPopup"
                    size="small"
                    aria-label="Close"
                    onClick={handleDialogClose}
                    sx={{
                        color: "common.white",
                        "&:hover": { bgcolor: "rgba(255,255,255,0.14)" },
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent sx={{ bgcolor: "#ffffff", pt: 3.5, pb: 2.5, px: 2.5 }}>
                <Grid container spacing={2} marginTop={2}>
                    <Grid item lg={3} sx={{ padding: '10px', display: 'flex', flexDirection: 'column' }}>
                        <label>Employee Type</label>
                        <FormControl className='form-control'>
                            <RadioGroup
                                row
                                name="roleType"
                                value={selectedRoleType}
                            // onChange={handleChangeRoleType}
                            >
                                <FormControlLabel value="1" control={<Radio disabled />} label="Commercial" />
                                <FormControlLabel value="2" control={<Radio disabled />} label="Technical" />
                            </RadioGroup>
                        </FormControl>
                    </Grid>

                    <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Office Code</label>
                        <TextField type='number' maxLength='5' readOnly onChange={handleChange} name="iv_office_code" value={values.iv_office_code} onBlur={handleBlur} disabled sx={{
                            width: '100%',
                            "& .MuiOutlinedInput-root": {
                                borderRadius: 1.5,
                                bgcolor: "#eef1f7",
                            },
                        }} />
                    </Grid>


                    {
                        selectedRoleType == "1" &&
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                            <label>Level</label>
                            <Select
                                fullWidth
                                value={values.iv_level}
                                onChange={handleLevelChange}
                                sx={{ height: '45px', width: '100%' }}
                                onBlur={handleBlur}
                                name="iv_level"
                                id="iv_level"
                            >
                                <MenuItem >Select Level</MenuItem>
                                {
                                    cfcLevelList.map(item => <MenuItem value={item.cfcLevelId}>{item.cfcLevelName}</MenuItem>)
                                }
                            </Select>
                            <Grid>
                                {
                                    errors.iv_level && touched.iv_level ? (
                                        <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                                    ) : null
                                }
                            </Grid>
                        </Grid>
                    } {
                        selectedRoleType == "2" &&
                        <Grid item lg={3} sx={{ padding: '10px' }}>
                            <label>Level</label>
                            <Select
                                fullWidth
                                value={values.iv_level}
                                onChange={handleLevelChange}
                                sx={{ height: '45px', width: '100%' }}
                                onBlur={handleBlur}
                                name="iv_level"
                                id="iv_level"
                            >
                                <MenuItem >Select Level</MenuItem>
                                {
                                    technicalLevels.map(item => <MenuItem value={item.value}>{item.label}</MenuItem>)
                                }
                            </Select>
                            <Grid>
                                {
                                    errors.iv_level && touched.iv_level ? (
                                        <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_level}</p>
                                    ) : null
                                }
                            </Grid>
                        </Grid>
                    }

                    {
                        values.iv_level > 1 ?
                            <>
                                <Grid item lg={3} sx={{ padding: '10px' }}>
                                    <label>Company</label>
                                    <Select
                                        fullWidth
                                        disabled={parseInt(hierarchy) != 1}
                                        value={values.iv_company}
                                        onChange={handleChangeCompany}
                                        sx={{ height: '45px' }}
                                        onBlur={handleBlur}
                                        name="iv_company"
                                        id="iv_company"
                                    >
                                        <MenuItem >Select Company</MenuItem>
                                        {
                                            values.iv_level > 1 ?
                                                companyList.map((item) =>
                                                    item.code > 1 ?
                                                        <MenuItem value={item.code}>{item.name}</MenuItem> : null) :
                                                companyList.map((item) =>
                                                    <MenuItem value={item.code}>{item.name}</MenuItem>)
                                        }
                                    </Select>
                                    <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                                        {errors.iv_company && touched.iv_company ? (errors.iv_company) : null}
                                    </Grid>
                                </Grid>
                            </> : null
                    }
                    {
                        values.iv_level > 2 ?
                            <Grid item lg={3} sx={{ padding: '10px' }}>
                                <label>Circle</label>
                                <Select
                                    fullWidth
                                    value={values.iv_circle}
                                    onChange={handleChangeCircle}
                                    sx={{ height: '45px' }}
                                    onBlur={handleBlur}
                                    //displayEmpty
                                    name="iv_circle"
                                    id="iv_circle"
                                >
                                    <MenuItem>Select Circle</MenuItem>
                                    {
                                        circleList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                                    }
                                </Select>
                                <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                                    {errors.iv_circle && touched.iv_circle ? (errors.iv_circle) : null}
                                </Grid>
                            </Grid>
                            : null
                    }
                    {
                        [4, 51, 5, 52].includes(Number(values.iv_level)) ?
                            <Grid item lg={3} sx={{ padding: '10px' }}>
                                <label>Division</label>
                                <Select
                                    fullWidth
                                    value={values.iv_division}
                                    onChange={handleChangeDivision}
                                    sx={{ height: '45px' }}
                                    onBlur={handleBlur}
                                    //displayEmpty
                                    name="iv_division"
                                    id="iv_division"
                                >
                                    <MenuItem>Select Division</MenuItem>
                                    {
                                        divisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                                    }
                                </Select>
                                <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                                    {errors.iv_division && touched.iv_division ? (errors.iv_division) : null}
                                </Grid>
                            </Grid>
                            : null
                    }
                    
                    {
                        [5, 52].includes(values.iv_level) ?
                            <Grid item lg={3} sx={{ padding: '10px' }}>
                                <label>Sub Division</label>
                                <Select
                                    fullWidth
                                    value={values.iv_sub_division}
                                    onChange={handleChangeSubDivision}
                                    sx={{ height: '45px' }}
                                    onBlur={handleBlur}
                                    //displayEmpty
                                    name="iv_sub_division"
                                    id="iv_sub_division"
                                >
                                    <MenuItem>Select Sub Division</MenuItem>
                                    {
                                        subdivisionList.map(item => <MenuItem value={item.code}>{item.name}</MenuItem>)
                                    }
                                </Select>
                                <Grid sx={{ color: '#f73232', fontSize: '1rem' }}>
                                    {errors.iv_sub_division && touched.iv_sub_division ? (errors.iv_sub_division) : null}
                                </Grid>
                            </Grid>
                            : null
                    }

                   {
    selectedRoleType == "1" ?
        <Grid item lg={3} sx={{ padding: '10px' }}>
            <label>Customer Support Center</label>
            <FormControl 
                fullWidth 
                error={touched.iv_support_center && Boolean(errors.iv_support_center)}
                sx={{ height: '45px' }}
            >
                <Select
                    name="iv_support_center"
                    value={values.iv_support_center || ''}
                    onChange={handleChangeSupportCenter}
                    onBlur={handleBlur}
                    id="iv_support_center"
                    sx={{ height: '45px' }}
                >
                    <MenuItem value="">Select Customer Support Center</MenuItem>
                    {
                        cfcsList.map(item => (
                            <MenuItem key={item.cfcId} value={item.cfcId}>
                                {item.cfcName}
                            </MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>
                    {touched.iv_support_center && errors.iv_support_center}
                </FormHelperText>
            </FormControl>
        </Grid>
        : null
}
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                        <label>Remarks</label>
                        <TextField
                            fullWidth
                            autoComplete="off"
                            name="iv_remarks"
                            value={values.iv_remarks}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            id="iv_remarks"
                            sx={{
                                "& .MuiInputBase-root": {
                                    height: 44,
                                },
                            }}
                        />
                        <Box sx={{ color: colors.errorColor }}>
                            {errors.iv_remarks && touched.iv_remarks
                                ? errors.iv_remarks
                                : null}
                        </Box>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                        <Typography
                            className="fieldLabel"
                        >
                            Transfer Date
                        </Typography>
                        <input
    name="iv_transfer_date"
    type="date"
    value={values.iv_transfer_date}
    onChange={handleChange}  
    onBlur={handleBlur}
    max={new Date().toISOString().split("T")[0]}
    className="fieldReferenceNo"
    style={{ width: "100%", height: "44px", padding: "4px 8px", borderColor: '#c4c4c4', boxSizing: 'border-box' }}
/>

                        <Box sx={{ color: colors.errorColor }}>
                            {errors.iv_transfer_date && touched.iv_transfer_date
                                ? errors.iv_transfer_date
                                : null}
                        </Box>
                    </Grid>
                    <Grid item lg={3} sx={{ padding: '10px' }}>
                        <Typography className="documentLabel">
                            Transfer Letter
                        </Typography>
                        {transferLetterDoc ? (
                            <>
                                <Button
                                    component="label"
                                    startIcon={
                                        <CloseIcon
                                            className="button-with-image"
                                            onClick={() => {
                                                setTransferLetterDoc("");
                                            }}
                                        />
                                    }
                                >
                                    {transferLetterThumbnail &&
                                        isImage(transferLetterDoc) ? (
                                        <div className="btn-div">
                                            <img
                                                src={transferLetterThumbnail}
                                                alt="Transfer Letter"
                                                width="80"
                                            />
                                            {/* <p>{propertyDocumentsFileName}</p> */}
                                        </div>
                                    ) : (
                                        <span>
                                            {isPdf(transferLetterDoc) ? (
                                                <div className="btn-div">
                                                    <img src={pdfIcon} alt="PDF" width="80" />
                                                    {/* <p>{propertyDocumentsFileName}</p> */}
                                                </div>
                                            ) : (
                                                "Other file type"
                                            )}
                                        </span>
                                    )}
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button
                                    variant="outlined"
                                    component="label"
                                    startIcon={<FileUploadOutlinedIcon />}
                                    sx={{ borderRadius: 1.5, textTransform: "uppercase", fontWeight: 600 }}
                                >
                                    Upload
                                    <input
                                        hidden
                                        accept={documentExtensions}
                                        id="iv_transfer_letter"
                                        name="iv_transfer_letter"
                                        type="file"
                                        onChange={TransferDocuments}
                                    />
                                </Button>
                                 <Box className="documentError" sx={{ color: colors.errorColor }}>
                            {" "}
                            {errors.iv_transfer_letter && touched.iv_transfer_letter
                                ? errors.iv_transfer_letter
                                : null}
                        </Box>
                            </>
                        )}
                    </Grid>
                    <Grid item lg={12} sx={{ backgroundColor: '#d5e5ff', margin: '10px', padding: '5px' }}>
                      <h4 style={{ color: '#006ad1' }}>
                        User Role
                      </h4>
                    </Grid>
                    <Grid item lg={12} sx={{ padding: '0px 10px' }}>
                      {
                        values.iv_level &&
                        <>
                          <Grid>
                            {
                              errors.iv_role && touched.iv_role ? (
                                <p style={{ color: '#f73232', fontSize: '1rem' }}>{errors.iv_role}</p>
                              ) : null
                            }
                          </Grid>
                        </>

                      }
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-label"
                          name="iv_role"
                          id="iv_role"
                          value={isRoleManuallyChanged ? values.iv_role : selectedRoleId || ''}
                          onChange={(e) => {
                            setIsRoleManuallyChanged(true);
                            setFieldValue('iv_role', e.target.value); // updates Formik value
                          }}
                          onBlur={handleBlur}
                        >
                          <Grid sx={{ width: '100%' }}>
                            {
                              allRoles && allRoles.map((item) => {
                                const level = values.iv_level;
                                const roleTypeId = selectedRoleType;

                                if (
                                  (
                                    level == 4 &&
                                    (item.level == 4 || item.level == 51 ) &&
                                    item.roleTypeId == roleTypeId
                                  ) ||
                                  (
                                    level != 4 &&
                                    item.level == level &&
                                    item.roleTypeId == roleTypeId
                                  )
                                ) {
                                  return (
                                    <FormControlLabel
                                      key={item.id}
                                      sx={{
                                        padding: '0px 22.5px',
                                        backgroundColor: 'white',
                                        borderRadius: '5px',
                                        marginLeft: '0px',
                                        border: '1px solid lightgrey',
                                        marginBottom: '10px'
                                      }}
                                      value={item.id}
                                      control={<Radio />}
                                      label={item.name}
                                    />
                                  );
                                }

                                return null;
                              })
                            }

                          </Grid>
                        </RadioGroup>
                      </FormControl>

                    </Grid>

                    <Grid item lg={12} >
                        {
                            error &&
                            <Error
                                error={error}
                                onClose={() => errorCloses()}
                                backgroundColor="#FFC0CB"
                                textColor="#bb0303"
                                iconColor="#bb0303"
                            />
                        }
                    </Grid>
                    <Grid item lg={12} sx={{ display: 'flex', justifyContent: 'flex-end', padding: '10px' }}>
                      <Button 
    onClick={async (e) => {
        e.preventDefault();
        
        const validationErrors = await validateForm();
        
        // Show which fields are invalid
        Object.keys(validationErrors).forEach(key => {
        });
        
        if (Object.keys(validationErrors).length === 0) {
            handleSubmit();
        } else {
            // Trigger touch on all fields to show errors
            setTouched(Object.keys(validationErrors).reduce((acc, key) => {
                acc[key] = true;
                return acc;
            }, {}));
        }
    }}
    sx={TRANSFER_DIALOG_PRIMARY_BUTTON_SX}
    variant="contained" 
    size='medium'
>
    SUBMIT
</Button>
                    </Grid>
                </Grid>
            </DialogContent>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop>
        </Dialog>
    );
};

export default UpdateUserPopup;